<template>
    <div class="row items-center">
        <q-field style="width: 300px;">
            <q-input
                v-model="promoCodeInput"
                @click="editPromoCode"
                @focus="$event => selectText($event)"
                @blur="applyChanges"
                :loading="loading"
                placeholder="Введите промокод"
                ref="input"/>
            <q-btn icon="clear" @click="discardChanges" flat round color="primary" class="field-edit-button">
                <q-tooltip>Отменить редактирование</q-tooltip>
            </q-btn>
            <q-popover v-model="searchOpened" :no-focus="true" :no-refocus="true" :anchor-click="false"
                       anchor="bottom left" self="top left"
                       :offset="[0, -5]" max-height="300px">
                <q-infinite-scroll :handler="loadMoreProjects" :offset="20">
                    <q-list no-border>
                        <q-item v-for="(item, index) in projectsList" :key="index"
                                @click.native="changePromoCode(item)" link>
                            {{ item.service_code }} <{{ item.name }}>
                        </q-item>
                    </q-list>
                    <div class="row justify-center">
                        <q-spinner-dots v-show="loading" :size="25"/>
                    </div>
                </q-infinite-scroll>
                <div v-if="!projectsList.length" class="q-ma-md">
                    <span style="font-style: italic; font-size: 12px;">Проект не найден</span>
                </div>
            </q-popover>
        </q-field>
        <q-btn :disable="!canSave" icon="save" @click="applyChanges" flat round>
            <q-tooltip>Сохранить</q-tooltip>
        </q-btn>
    </div>
</template>

<script>
import {mapState} from 'vuex'
import {
  QField,
  QInput,
  QBtn,
  QTooltip,
  QPopover,
  QList,
  QItem,
  QInfiniteScroll,
  QSpinnerDots
} from 'quasar';

export default {
  name: "ProjectPromoCode",
  components: {
    QField,
    QInput,
    QBtn,
    QTooltip,
    QPopover,
    QList,
    QItem,
    QInfiniteScroll,
    QSpinnerDots,
  },
  computed: {
    ...mapState({
      project: state => state.project.data,
      promoCode: state => state.project.data.promo_code,
    }),
    currentPromoCode () {
      return this.promoCode ?? null
    },
  },
  watch: {
    promoCodeInput (value) {
      clearTimeout(this.inputDelayTimer);
      this.canSave = false;

      if (value === this.currentPromoCode) {
        return;
      }

      if (value.length >= 2) {
        this.inputDelayTimer = setTimeout(() => {
          this.query = value;
          this.projectsList = [];
          this.projectsListPage = 1;
          this.findProject(value);
        }, this.inputDelay);
      } else {
        this.searchOpened = false;
      }

      if (!value) {
        this.canSave = true;
      }
    },
    currentPromoCode (value) {
      this.promoCodeInput = value ?? ''
    }
  },
  data () {
    return {
      editMode: false,
      searchOpened: false,
      promoCodeInput: null,
      query: '',
      projectsList: [],
      projectsListPage: 1,
      projectsListPagesCount: 1,
      canSave: false,
      loading: false,
      inputDelay: 500,
      inputDelayTimer: null
    }
  },
  mounted () {
    this.promoCodeInput = this.currentPromoCode
  },
  methods: {
    editPromoCode () {
      this.editMode = true;
    },
    applyChanges (e) {
      if (e.relatedTarget && e.relatedTarget.classList.contains('q-popover')) {
        return;
      }

      if (this.promoCodeInput === this.currentPromoCode || !this.editMode) {
        this.canSave = false;
        return;
      }

      this.saveChanges();
    },
    discardChanges () {
      this.editMode = false;
      this.promoCodeInput = this.currentPromoCode ?? ''
    },
    saveChanges () {
      this.loading = true;
      this.editMode = false;
      const newProjectData = {
        ...this.project,
        promo_code: this.promoCodeInput ? this.promoCodeInput : null,
      }

      this.$http.put(`api/v1.0/projects/${this.$route.params.id}`, newProjectData).then(() => {
        this.$q.notify({
          message: `Сохранено`,
          type: 'info',
          position: 'bottom'
        });
        this.canSave = false;
        this.loading = false;
        this.$store.commit('project/setProject', newProjectData);
      }).catch((error) => {
        if (error?.response?.data?.errors) {
          _.forIn(error.response.data.errors, (value, key) => {
            this.$q.notify(value[0]);
          })
        } else {
          this.$q.notify({ message: 'Возникала ошибка при сохранении.', type: 'negative' })
        }
      });
    },
    findProject (query, page = 1) {
      this.loading = true;
      return this.$http.get(`api/v1.0/projects/?filter[service_code]=${query}&page=${page}`).then(response => {
        this.projectsList = [...this.projectsList, ...response.data.projects];
        this.projectsListPagesCount = response.data.pagesCount;
        this.searchOpened = true;
        this.loading = false;
      });
    },
    loadMoreProjects (_i, done) {
      if (this.projectsListPagesCount > this.projectsListPage) {
        this.findProject(this.query, ++this.projectsListPage).then(() => done());
      } else {
        done();
      }
    },
    changePromoCode (referrer) {
      this.promoCodeInput = referrer.service_code;
      this.searchOpened = false;
      this.canSave = true;

      setTimeout(() => {
        this.$refs.input.focus();
        this.$refs.input.$refs.input.select();
      })
    },
    selectText ($event) {
      $event.target.select();
    },
  }
}
</script>

<style scoped>
.q-btn.disabled {
    opacity: 0.2 !important;
}
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/ProjectPromoCode/ProjectPromoCode.vue